import { useContext } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import { Box, Chip, Container, LayoutVertical, Loader, StepCard, Typography } from "@/components";
import { FetchContext as context } from "@/contexts/FetchContext";
import getPortalType from "@/utils/getPortalType";

import { PasswordChangeAuthMailForm } from "./components/PasswordChange/Forms";

export const PasswordChangeAuthMail = () => {
  const { t } = useTranslation();
  const { state } = useContext(context);

  return (
    <Container>
      <Helmet title={t("CHANGE_PASSWORD")} />
      <LayoutVertical>
        {state.loading || !state.data?.user.driverCode ? (
          <Loader url={((p): string => (p ? `/${p}_portal/account/error/500` : "/"))(getPortalType())} />
        ) : (
          <>
            <Typography variant="h1">{t("CHANGE_PASSWORD")}</Typography>
            <StepCard activestep={0} steplength={4}>
              <Typography variant="h2" gutterBottom>
                {t("PLEASE_SEND_PIN_CODE")}
              </Typography>
              <Typography component="h3" variant="body1">
                {t("PLEASE_SEND_PIN_CODE_BY_EMAIL")}
              </Typography>
              <Box textAlign="center" style={{ marginTop: "24px" }}>
                <Chip label={state.data.user.mailAddress} size="medium" />
                <PasswordChangeAuthMailForm />
              </Box>
            </StepCard>
          </>
        )}
      </LayoutVertical>
    </Container>
  );
};
